module.exports = __webpack_public_path__ + "static/media/volleyball-ball.a5e93316.svg";